import React from 'react';
import { Outlet } from 'react-router-dom';

const Dtr = () => {
    return (
        <div className='dtr'>
            <Outlet />
        </div>
    )
}

export default Dtr;
